import React, { useState } from 'react';
import { Box, Paper, Typography, TableContainer, Table, TableBody, TableCell, TableRow, Card, CardHeader, ToggleButton, ToggleButtonGroup, Stack } from '@mui/material';
import { BarChart, Dataset, Share, Facebook, LinkedIn, X } from '@mui/icons-material';
import Grid from '@mui/material/Grid';
import renderPercentage from '../renderPercentage';
import { useTheme } from '@mui/material/styles';
import EmailSharesChart from '../charts/EmailSharesChart';
import { lighten } from '@mui/system';
import ChannelTotalButton from './ChannelTotalButton';
import ReportsCardContent from './ReportsCardContent';
import { channelColours } from '../../theme/constants';
import TypedValue from '../../TypedValue';

const Shares = ({ selected, socialActions, onChangeTab }) => {
    const [isChartView, setIsChartView] = useState(true);
    const theme = useTheme();

    const facebook = socialActions.find(e => e.type.toLowerCase() === 'facebook' && e.action.toLowerCase().includes('post'))?.total || 0;
    const twitter = socialActions.find(e => e.type.toLowerCase() === 'twitter' && e.action.toLowerCase().includes('post'))?.total || 0;
    const linkedin = socialActions.find(e => e.type.toLowerCase() === 'linkedin' && e.action.toLowerCase().includes('post'))?.total || 0;

    const allShares = facebook + twitter + linkedin;

    const handleChange = (event, value) => {
        value !== null && setIsChartView(value);
    };

    return (
        <Card sx={{ height: '100%' }}>
            <CardHeader
                sx={{
                    m: 0,
                    py: 1,
                    '& .MuiCardHeader-action': {
                        alignSelf: 'center'
                    }
                }}
                slotProps={{
                    title: {
                        variant: 'h6',
                        fontWeight: 'normal'
                    }
                }}
                avatar={<Share />}
                title="Shares"
                action={(
                    <ToggleButtonGroup
                        size="small"
                        color="primary"
                        value={isChartView}
                        exclusive
                        onChange={handleChange}
                        aria-label="View"
                        sx={{
                            mr: 1
                        }}
                    >
                        <ToggleButton value={false}><Dataset fontSize="inherit" /></ToggleButton>
                        <ToggleButton value={true}><BarChart fontSize="inherit" /></ToggleButton>
                    </ToggleButtonGroup>
                )}
            />
            {isChartView ? (
                <EmailSharesChart
                    allShares={allShares}
                    selected={selected}
                    facebook={facebook}
                    twitter={twitter}
                    linkedin={linkedin}
                />
            ) : (
                <ReportsCardContent>
                    <Stack spacing={2}>
                        <Paper variant="outlined" sx={{ backgroundColor: lighten(theme.palette.primary.main, 0.9) }}>
                            <TableContainer>
                                <Table size="small">
                                    <TableBody>
                                        <TableRow>
                                            <TableCell variant="head">
                                                Total
                                            </TableCell>
                                            <TableCell align="right" width="30%">
                                                <Typography variant="h6" color="primary">
                                                    <TypedValue value={allShares} type="number" accuracy={0} />
                                                </Typography>
                                            </TableCell>
                                            <TableCell align="right" width="20%">
                                                {renderPercentage(allShares, selected)}
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Paper>
                        <Box>
                            <Grid container spacing={2}>
                                <Grid size={4}>
                                    <ChannelTotalButton
                                        onClick={() => onChangeTab('Channels')}
                                        value={facebook}
                                        text="Facebook"
                                        tabShown={false}
                                        icon={<Facebook sx={{ color: channelColours.facebook }} fontSize="small" />}
                                    />
                                </Grid>
                                <Grid size={4}>
                                    <ChannelTotalButton
                                        onClick={() => onChangeTab('Channels')}
                                        value={linkedin}
                                        text="LinkedIn"
                                        tabShown={false}
                                        icon={<LinkedIn sx={{ color: channelColours.linkedin }} fontSize="small" />}
                                    />
                                </Grid>
                                <Grid size={4}>
                                    <ChannelTotalButton
                                        onClick={() => onChangeTab('Channels')}
                                        value={twitter}
                                        text="X"
                                        tabShown={false}
                                        icon={<X sx={{ color: channelColours.x }} fontSize="small" />}
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                    </Stack>
                </ReportsCardContent>
            )}
        </Card>
    );
};

export default Shares;